export const PAGE_WIDTH = 612;
export const PAGE_HEIGHT = 792;
export const PAGE_MARGIN_HORIZONTAL = 36;
export const PAGE_CONTENT_TOP = 228;
export const PAGE_FOOTER_MARGIN = 90;
export const PAGE_CONTENT_BOTTOM = PAGE_HEIGHT - PAGE_FOOTER_MARGIN;
export const PAGE_CONTENT_HEIGHT = PAGE_CONTENT_BOTTOM - PAGE_CONTENT_TOP;
export const CONTENT_WIDTH = PAGE_WIDTH - PAGE_MARGIN_HORIZONTAL * 2;

/** Total table width — kept slightly inside the content area for border/padding safety. */
export const TABLE_WIDTH = CONTENT_WIDTH - 8;

export const PDF_LINE_INDENT = 22;
export const PDF_AMOUNT_COLUMN_WIDTH = 72;

export const PDF_NO_BORDER_LAYOUT = {
  hLineWidth: () => 0,
  vLineWidth: () => 0,
  paddingLeft: () => 0,
  paddingRight: () => 0,
  paddingTop: () => 0,
  paddingBottom: () => 0,
};
